<template>
    <PlanbordStampStartDateCell>
        {{ stampStartDate }}
    </PlanbordStampStartDateCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import Dates from '@cquential/date-utils';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';

    @Component({
        components: {
            PlanbordStampStartDateCell,
        },
    })
    export default class ResourceStampStartDateCell extends Vue {
        @Prop({required: true}) public resource!: ResourceWithKeyedByDateObjects;

        public get stampStartDate(): string {
            if (!this.resource.stampDeployedUntil) {
                return '';
            }

            const stampStartDate: Date = Dates.Utils.addDays(this.resource.stampDeployedUntil, 1);

            return Dates.Formatter.formatDateWithWeekDayShortMonthAndYear(stampStartDate);
        }
    }
</script>
